import { GridRowsImage } from './GridRowsImage';

export const LoadingOverlay = () => {
  return (
      <GridRowsImage label="Loading..." />
  );
};
